import { render } from "./LinksPage.vue?vue&type=template&id=2331648c&scoped=true"
import script from "./LinksPage.vue?vue&type=script&lang=js"
export * from "./LinksPage.vue?vue&type=script&lang=js"

import "./LinksPage.vue?vue&type=style&index=0&id=2331648c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2331648c"]])

export default __exports__